import React, { FC, useEffect } from 'react';
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import { useDispatch } from 'store';
import { loadRfpResponsesList } from 'store/rfpReviewerList';

import ProjectList from './components/ProjectList/ProjectList';
import Announcement from './components/Announcement/Announcement';
import HeadInfo from './components/HeadInfo/HeadInfo';

import './ReviewerDashboard.scss';

export interface DashboardProps {}

const ReviewerDashboard: FC<DashboardProps> = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadRfpResponsesList());
  }, [dispatch]);

  return (
    <div className="enkrateia-reviewer-dashboard">
      <Header />
      <div className="content">
        <HeadInfo />
        <div className="divider"></div>
        <Announcement />
        <ProjectList />
      </div>
      <Footer />
    </div>
  );
};

export default ReviewerDashboard;
